import { typeFn } from '#utils/typeFn';

// eslint-disable-next-line @typescript-eslint/no-wrapper-object-types
const fn = typeFn<String>()();

export default fn;
